import { render, staticRenderFns } from "./CustomerInfoEmergencyContacts.vue?vue&type=template&id=ab9e55ac"
import script from "./CustomerInfoEmergencyContacts.vue?vue&type=script&lang=js"
export * from "./CustomerInfoEmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports